import React from 'react';
import AgentMark from './AgentMark';

/**
 * Backward-compatible DigipingMark wrapper that routes through AgentMark.
 * Automatically adapts colors and geometry based on agentId or brand.
 *
 * @param {{
 *   agentId?: string,
 *   size?: number,
 *   className?: string,
 *   primary?: string,
 *   accent?: string,
 *   showGlow?: boolean,
 *   title?: string,
 * }} props
 */
export default function DigipingMark({
  agentId = 'pingflo',
  size = 40,
  className = '',
  primary,
  accent,
  showGlow = false,
  title,
}) {
  return (
    <AgentMark
      agentId={agentId}
      size={size}
      className={className}
      primary={primary}
      accent={accent}
      showGlow={showGlow}
      title={title}
    />
  );
}
